import { Injectable, inject } from '@angular/core';

import { CodedStatusMessage } from '@gfe/core/models/coded-status-message.model';

import { GbeError } from '@core/models/gbe/gbe-error.model';

import { WarningPresenter } from './warning-presenter.service';
import { WarningView } from './warning.model';

@Injectable({ providedIn: 'root' })
export class GbeErrorParserService {
  private readonly presenter = inject(WarningPresenter);

  /**
   * Several views because `multiple_errors` carries inner errors with their own
   * codes and titles, and one view may carry several occurrences when a single
   * details payload describes several violations.
   */
  resolve(message: CodedStatusMessage): WarningView[] {
    return this.presenter.present(message);
  }

  /**
   * Kept as a named entry point because callers hold a `GbeError` from the error
   * interceptor; it is the same envelope plus an HTTP status.
   */
  resolveError(error: GbeError): WarningView[] {
    return this.resolve(error);
  }
}
